import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth'
import { firebaseAuth } from './FirebaseConfig'
import { IAuthenticationResult } from "../interfaces/IAuthenticationResult";
import api from "./Api";

class AuthService {
    async signIn(email: string, senha: string): Promise<IAuthenticationResult> {
        const credential = await signInWithEmailAndPassword(firebaseAuth, email, senha)
        const idToken = await credential.user.getIdToken()

        const { data: result } = await api.post<IAuthenticationResult>('auth', { idToken }, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3',
        });

        // AuthService.LoginAsync (backend) acabou de setar o custom claim "clienteId" nesse
        // usuário (usado pelas Security Rules do Firestore de notificações em tempo real) — mas
        // o idToken acima foi emitido ANTES disso, então não carrega o claim. Sem forçar o
        // refresh aqui, o board só teria o claim depois do refresh automático do SDK (~1h),
        // e até lá toda leitura do Firestore seria negada silenciosamente pelas rules.
        await credential.user.getIdToken(true);

        return result;
    }

    async resetPassword(email: string): Promise<void> {
        await sendPasswordResetEmail(firebaseAuth, email);
    }

    async recoverPassword(newPass: string, key: string): Promise<void> {
        await api.post('Autenticacao/recuperar-senha', { novaSenha: newPass, chave: key });
    }
}


export default new AuthService();